import React from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck, Clock, Star } from "lucide-react";
import { Button, cn } from "../../../../design-system/index.js";

const BADGES = [
  { icon: ShieldCheck, label: "Verificadas" },
  { icon: Star, label: "Avaliadas" },
  { icon: Clock, label: "Agendamento fácil" },
];

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section
      id="hero"
      className={cn(
        "relative min-h-[calc(100vh-4rem)] flex items-center overflow-hidden",
        "bg-gradient-to-br from-[var(--color-warm-50)] via-white to-[var(--color-warm-100)] pt-16"
      )}
    >
      {/* Blob decorativos */}
      <div className="pointer-events-none absolute -top-32 -left-32 h-96 w-96 rounded-full bg-[var(--color-rose-400)/12] blur-3xl" />
      <div className="pointer-events-none absolute -bottom-24 right-0 h-72 w-72 rounded-full bg-[var(--color-slate-blue-400)/10] blur-3xl" />

      <div className="relative mx-auto w-full max-w-6xl px-4 sm:px-6 py-12 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">

          {/* Texto */}
          <div className="order-2 md:order-1 text-center md:text-left">
            <span className={cn(
              "inline-block rounded-full bg-[var(--color-rose-400)/12]",
              "px-3 py-1 text-xs font-semibold text-[var(--color-rose-400)] mb-4"
            )}>
              Plataforma de babás verificadas
            </span>

            <h1 className={cn(
              "font-heading text-4xl sm:text-5xl md:text-5xl lg:text-6xl",
              "font-bold leading-tight text-[var(--color-warm-900)]"
            )}>
              Babás de confiança{" "}
              <span className="text-[var(--color-rose-400)]">
                para sua família
              </span>
            </h1>

            <p className={cn(
              "mt-5 text-base sm:text-lg text-[var(--color-warm-600)]",
              "max-w-lg mx-auto md:mx-0 leading-relaxed"
            )}>
              Cuidar do seu tesourinho é a nossa missão. Profissionais
              verificadas, carinho e segurança em cada momento.
            </p>

            {/* Badges */}
            <div className="mt-6 flex flex-wrap justify-center md:justify-start gap-2">
              {BADGES.map(({ icon: Icon, label }) => (
                <span
                  key={label}
                  className={cn(
                    "flex items-center gap-1.5 rounded-full",
                    "border border-[var(--color-warm-200)] bg-white",
                    "px-3 py-1.5 text-xs font-medium text-[var(--color-warm-700)] shadow-sm"
                  )}
                >
                  <Icon size={13} className="text-[var(--color-rose-400)]" />
                  {label}
                </span>
              ))}
            </div>

            {/* CTAs */}
            <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center md:justify-start">
              <Button
                variant="default"
                size="lg"
                className="rounded-full px-6 py-3 font-bold shadow-md hover:shadow-lg"
                onClick={() => navigate("/para-babas")}
              >
                Para as Babás
              </Button>
              <Button
                variant="outline"
                size="lg"
                className={cn(
                  "rounded-full border-2 border-[var(--color-slate-blue-400)]",
                  "px-6 py-3 font-bold text-[var(--color-slate-blue-400)]",
                  "hover:bg-[var(--color-slate-blue-400)/8]"
                )}
                onClick={() => navigate("/para-familias")}
              >
                Para as Famílias
              </Button>
            </div>
          </div>

          {/* Imagem */}
          <div className="order-1 md:order-2 flex justify-center">
            <div className="relative">
              {/* Círculo decorativo atrás da imagem */}
              <div className="absolute inset-0 rounded-full bg-gradient-to-br from-[var(--color-rose-400)/20] to-[var(--color-slate-blue-400)/15] blur-2xl scale-110" />
              <img
                src="/assets/img-baba-transparente.webp"
                alt="Babá cuidando de criança"
                className="relative z-10 h-64 sm:h-80 md:h-96 w-auto object-contain drop-shadow-xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}